
import { Separator } from "@/components/ui/separator";
import { FooterLogo } from "./footer/FooterLogo";
import { FooterLinkSection } from "./footer/FooterLinkSection";
import { FooterSocialSection } from "./footer/FooterSocialSection";
import { NewsletterSignup } from "@/components/newsletter/NewsletterSignup";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const exploreLinks = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Blog", path: "/blog" },
    { label: "What's New", path: "/whats-new" },
  ];

  const getStartedLinks = [
    { label: "Library", path: "/library" },
    { label: "Pricing", path: "/pricing" },
    { label: "FAQ", path: "/faq" },
    { label: "Feedback", path: "/beta-feedback" },
  ];
  
  const legalLinks = [
    { label: "Privacy Policy", path: "/legal/privacy" },
    { label: "Terms of Service", path: "/legal/terms" },
    { label: "Cookie Policy", path: "/legal/cookies" },
  ];
  
  return (
    <footer className="bg-gradient-to-b from-yarn-ivory via-yarn-quartz to-yarn-warm-gray border-t border-yarn-orchid/10 shadow-lg relative">
      {/* Subtle pattern overlay */}
      <div 
        className="absolute inset-0 opacity-15 pointer-events-none mix-blend-soft-light" 
        style={{
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23622066' fill-opacity='0.10'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
        }}
      ></div>
      
      <div className="container py-16 md:py-14 px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-10 md:gap-8">
          <FooterLogo />

          <FooterLinkSection
            title="Explore"
            links={exploreLinks}
          />

          <FooterLinkSection
            title="Get Started"
            links={getStartedLinks}
          />

          <FooterLinkSection
            title="Legal"
            links={legalLinks}
          />

          <FooterSocialSection />

          <NewsletterSignup variant="inline" />
        </div>
        
        <Separator className="my-8 bg-yarn-orchid/10" />
        
        <div className="text-center text-sm text-yarn-slate">
          <p>&copy; {currentYear} IntelliStitch. All rights reserved.</p>
          <div className="mt-2 flex justify-center items-center gap-2">
            <span className="inline-block w-2 h-2 bg-yarn-orchid rounded-full"></span>
            <span className="font-medium">You knit. We calculate.</span>
            <span className="inline-block w-2 h-2 bg-yarn-orchid rounded-full"></span>
          </div>
        </div>
      </div>
    </footer>
  );
};
